import React from 'react'
import PropTypes from 'prop-types'

import createSearchResultBodyContainer from '../../../containers/searchResultBodyContainer'
import siteConfig from '../../../../common/utils/siteConfig'
import { reportProductsImpressions } from '../../../../common/analytics/resultAnalytics'
import ProductList from '../../../components/productList'
import { itemDecorator, isSearchResultMatchesEqual } from '../../../../common/utils/item'
import { getTopLevelRoute } from '../../../../common/utils/urlHelper'

class SearchResultBody extends React.Component {
  itemRankOffset () {
    const { currentSite, location } = this.props

    const pageSize = siteConfig(currentSite, 'common.search_page_size')

    return (((Number(location.query.page) || 1) - 1) * pageSize) + 1
  }

  componentDidMount () {
    const { matches, currentSite, location } = this.props
    reportProductsImpressions(matches, currentSite, this.itemRankOffset(), getTopLevelRoute(location.pathname))
  }

  componentDidUpdate (prevProps) {
    const prevMatches = prevProps.matches
    const { matches, currentSite, location } = this.props

    if (!isSearchResultMatchesEqual(prevMatches, matches)) {
      reportProductsImpressions(matches, currentSite, this.itemRankOffset(), getTopLevelRoute(location.pathname))
    }
  }

  render () {
    const {
      matches,
      createFavoriteCollection,
      currentSite,
      collections,
      cartItems,
      token,
      deleteBookmark,
      addBookmark,
      favoriteCollectionID,
      openModal,
      location,
      preferences
    } = this.props

    return <ProductList
      items={matches}
      currentSite={currentSite}
      preferences={preferences}
      itemDecorator={itemDecorator(currentSite, openModal, !token, favoriteCollectionID, collections, deleteBookmark, addBookmark, createFavoriteCollection, this.itemRankOffset(), cartItems, location)}
    />
  }
}

SearchResultBody.propTypes = {
  matches: PropTypes.array.isRequired,
  view: PropTypes.string
}

export default createSearchResultBodyContainer(SearchResultBody)



// WEBPACK FOOTER //
// ./client/pages/search/result/searchResultBody.js